module.exports = __webpack_public_path__ + "img/404.9a6b1d4.png";